import React from 'react';

export interface StackCellProps {
  /** Optional short initials shown above the title (muted). */
  initials?: string;
  /** Primary row title (bold). */
  title: React.ReactNode;
  /**
   * Meta lines joined visually with ` · ` (or custom nodes).
   * Always visible (desktop + mobile). Pass desktop-only fields via `stackExtra`.
   */
  meta?: React.ReactNode;
  /**
   * Extra meta shown only on mobile (≤640px / .app-mobile), when middle
   * columns are collapsed into the first cell. Hidden on desktop.
   */
  stackExtra?: React.ReactNode;
  className?: string;
}

/**
 * Shared DS cell for listing tables: stacked identity + meta.
 * On mobile the table collapses to [StackCell | Abrir] — put every desktop
 * column value either here or in `stackExtra` so nothing is missing.
 */
const StackCell: React.FC<StackCellProps> = ({
  initials,
  title,
  meta,
  stackExtra,
  className,
}) => (
  <div className={`stack-cell${className ? ` ${className}` : ''}`}>
    {initials ? <div className="stack-initials">{initials}</div> : null}
    <div className="stack-title">{title}</div>
    {meta ? <div className="stack-meta">{meta}</div> : null}
    {stackExtra ? <div className="stack-extra">{stackExtra}</div> : null}
  </div>
);

export default StackCell;
